var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobApplicationIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385.94,
    height: 654.73,
    viewBox: "0 0 385.94 654.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "job_application_icon6",
    transform: "translate(-77.582 -4221.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121647",
    "data-name": "\\uD328\\uC2A4 121647",
    d: "M10228.613,17549.688c-118.218,47.6-223.352,216.258-193.311,397.646s172.709,174.734,212.308,95.668-59.96-121.289-119.272-48.084,11.493,148.365,119.272,185.072,164.871,10.549,164.871,10.549",
    transform: "translate(-9950 -13326)",
    fill: "none",
    stroke: "#e6ebf1",
    strokeWidth: 5,
    strokeDasharray: "23 20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172485",
    "data-name": "\\uADF8\\uB8F9 172485",
    transform: "translate(80.114 4337.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121635",
    "data-name": "\\uD328\\uC2A4 121635",
    d: "M3222.156,1171.548s-25.334,21.934-35.873,26.7c16.581,39.2,41.941,44.973,41.941,44.973s14.666-13.628,31.148-32.762C3227.752,1199.3,3222.156,1171.548,3222.156,1171.548Z",
    transform: "translate(-3186.283 -1166.577)",
    fill: "#6b6b6b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121636",
    "data-name": "\\uD328\\uC2A4 121636",
    d: "M3222.156,1149.571s-25.334,21.934-35.873,26.7c16.581,39.2,41.941,44.973,41.941,44.973s14.666-13.628,31.148-32.761C3227.752,1177.326,3222.156,1149.571,3222.156,1149.571Z",
    transform: "translate(-3186.283 -1149.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121637",
    "data-name": "\\uD328\\uC2A4 121637",
    d: "M3248.975,1202.6a62.539,62.539,0,0,0-6.361,4.6c-2.1,1.6-4.205,3.192-6.294,4.806q-6.331,4.893-12.63,9.827c-.609.478.222,1.327.824.866q6.289-4.807,12.543-9.659c2.083-1.615,4.151-3.25,6.223-4.881a63.033,63.033,0,0,0,6.078-5.032A.328.328,0,0,0,3248.975,1202.6Z",
    transform: "translate(-3215.065 -1190.575)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121638",
    "data-name": "\\uD328\\uC2A4 121638",
    d: "M3268.345,1226.57a17.276,17.276,0,0,0-2.959,2.193c-1.023.825-2.025,1.676-3.036,2.516-1.974,1.643-3.955,3.279-5.922,4.93-3.978,3.339-7.976,6.661-11.908,10.054-.58.5.232,1.331.812.854,4.013-3.3,7.968-6.672,11.937-10.023,1.961-1.656,3.909-3.328,5.863-4.993,1-.852,2.007-1.694,2.994-2.56a17.082,17.082,0,0,0,2.638-2.533C3268.961,1226.74,3268.6,1226.441,3268.345,1226.57Z",
    transform: "translate(-3231.194 -1209.131)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121639",
    "data-name": "\\uD328\\uC2A4 121639",
    d: "M3285.233,1251.906a15.841,15.841,0,0,0-3.132,2.284c-.969.8-1.923,1.626-2.88,2.445q-3.007,2.571-6,5.154-5.99,5.169-11.972,10.346c-.6.525.251,1.413.854.9q6.01-5.146,12-10.318,3-2.581,5.982-5.177c.995-.865,1.991-1.727,2.974-2.606a14.913,14.913,0,0,0,2.559-2.627C3285.781,1252.054,3285.474,1251.79,3285.233,1251.906Z",
    transform: "translate(-3244.131 -1228.738)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121640",
    "data-name": "\\uD328\\uC2A4 121640",
    d: "M3310.754,1269.878c-2.283,1.515-4.151,3.757-6.055,5.706q-2.892,2.958-5.756,5.941l-5.87,6.083q-1.436,1.488-2.872,2.976-.749.778-1.492,1.56a4.294,4.294,0,0,0-.6.645c-.127.216-.081.479-.2.7a.265.265,0,0,0,.351.368c.248-.137.5-.113.736-.252a3.31,3.31,0,0,0,.566-.562q.752-.773,1.5-1.547,1.5-1.552,2.995-3.109l5.74-5.958q2.932-3.044,5.853-6.1c1.844-1.939,3.981-3.855,5.385-6.151C3311.149,1270.005,3310.939,1269.754,3310.754,1269.878Z",
    transform: "translate(-3264.904 -1242.642)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121641",
    "data-name": "\\uD328\\uC2A4 121641",
    d: "M3336.718,1302.917a43.622,43.622,0,0,0-5.479,5.266q-2.636,2.684-5.27,5.371c-3.588,3.67-7.267,7.271-10.765,11.025-.481.516.249,1.3.76.8,3.672-3.584,7.186-7.346,10.772-11.018q2.692-2.756,5.373-5.523a42.444,42.444,0,0,0,5.03-5.481C3337.3,1303.108,3336.978,1302.733,3336.718,1302.917Z",
    transform: "translate(-3285.923 -1268.196)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121642",
    "data-name": "\\uD328\\uC2A4 121642",
    d: "M3368.167,1330.028a13.409,13.409,0,0,0-2.777,2.4c-.905.884-1.788,1.791-2.677,2.69-1.738,1.756-3.454,3.535-5.179,5.3q-5.3,5.436-10.591,10.887c-.552.568.3,1.459.847.891q5.287-5.452,10.569-10.91c1.759-1.821,3.53-3.631,5.273-5.466.872-.918,1.756-1.827,2.609-2.761a13.117,13.117,0,0,0,2.22-2.729A.222.222,0,0,0,3368.167,1330.028Z",
    transform: "translate(-3310.466 -1289.19)",
    fill: "#303030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplicationIcon6);
export default __webpack_public_path__ + "static/media/job_application_icon6.39f0a9ab431d0144b957ff098b8bcfb7.svg";
export { ForwardRef as ReactComponent };